
import { Component, Vue } from 'vue-property-decorator'
import { TicketsModule } from '@/store/modules/tickets'
import { ORDERAPI } from '@/api/orders'
import { getuserCurrentApp } from '@/utils/cookies'
import { AppModule, DeviceType } from '@/store/modules/app'

@Component({
  name: 'PendingDialog',
  components: {}
})
export default class extends Vue {
  private btnLoading = false

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get dialogVisible() {
    return TicketsModule.unpendingDialog
  }

  get device() {
    return AppModule.device
  }

  get isMobile() {
    return this.device === DeviceType.Mobile
  }

  get currentTicket() {
    return TicketsModule.currentTicket
  }

  // 关闭弹框
  private handleClose() {
    TicketsModule.ToggleDialogStatus({
      name: 'unpendingDialog',
      value: false
    })
  }

  private handleUnPendingSubmit() {
    this.btnLoading = true
    ORDERAPI.unpendingTicket({
      tid: this.currentTicket.tid,
      t_type: this.currentTicket.ticket_type
    }, {
      app_id: this.userCurrentApp
    }).then(res => {
      if (res.stat === 1) {
        this.btnLoading = false
        this.$emit('handleSuccess', res)
        this.handleClose()
      }
    }).catch(_ => {
      this.btnLoading = false
    })
  }
}
